import SettingQuotaPane from '@src/views/setting/SettingQuotaPane';
import AsyncBoundary from '@src/components/shared/AsyncBoundary';
import { FallbackProps } from 'react-error-boundary';
import { Loading } from '@src/components/shared';
import KeywordFolderTree from './KeywordFolderTree';

export const MenuContent = () => {
  return (
    <AsyncBoundary
      ErrorFallback={(fallbackProps: FallbackProps) => (
        <div
          style={{
            padding: '16px',
            textAlign: 'center',
            color: '#8c8c8c',
            fontSize: '13px',
          }}
        >
          <p style={{ margin: '0 0 8px' }}>메뉴를 불러오지 못했습니다.</p>
          <button
            onClick={() => fallbackProps.resetErrorBoundary()}
            style={{
              background: 'none',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              padding: '4px 12px',
              cursor: 'pointer',
              fontSize: '12px',
              color: '#595959',
            }}
          >
            다시 시도
          </button>
        </div>
      )}
      SuspenseFallback={<Loading cover="content" />}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <div
          style={{
            flex: 1,
            overflowX: 'hidden',
          }}
        >
          <KeywordFolderTree />
        </div>
        <div
          style={{
            flexShrink: 0,
          }}
        >
          <SettingQuotaPane
            containerStyle={{ padding: '14px', paddingBottom: '56px' }}
            showTalkQuota={false}
          />
        </div>
      </div>
    </AsyncBoundary>
  );
};
